<template>
    <div class="productContainer">
        <!-- <div class="productImage" v-if="view == 'grid'"> -->
        <div class="productImage" >
            <a :href="$root.pointshop ? basedir+$root.pointshopUrlPrefix+product.productPageLink : basedir+'/'+product.productPageLink">
                <v-lazy-image 
                    :alt="product.name" 
                    :src-placeholder="product.imageUrl" 
                    :srcset="imageSet.set" 
                    :src="editing ? `${newImageUrl}?w=${imageSize}` : product.imageUrl+'?w='+imageSize" 
                    :size="imageSet.size"
                    @error="handleImageError" 
                />
                <!-- <img :alt="product.name" :title="product.name" :data-src="editing ? checkImageUrl(product.imageUrl) : product.imageUrl+'?w='+imageSize" :data-srcset="imageSet" /> -->
            </a>
        </div>
        <div class="productInfo">
            <a :href="$root.pointshop ? basedir+$root.pointshopUrlPrefix+product.productPageLink : basedir+'/'+product.productPageLink">
                <h3 v-html="editing ? editData.name : product.name"></h3>
            </a>
          
            <PromotionLabel :promotion="filteredPromotion" v-if="hasPromotion"/>
         
            <div style="float:right;" v-if="this.$root.admin && view == 'list'">
                <transition name="bounce">
                    <button v-if="!editing" class="edit btn" @click="editing = true"><i class="fa fa-pencil" aria-hidden="true"></i>Edit</button>
                </transition>
            </div>
            <!-- <div class="productImage" v-if="view == 'list' && mobile">
                <a :href="$root.pointshop ? basedir+$root.pointshopUrlPrefix+product.productPageLink : basedir+'/'+product.productPageLink">
                    <v-lazy-image 
                        :alt="product.name" 
                        :src-placeholder="product.imageUrl" 
                        :srcset="imageSet.set" :src="editing ? newImageUrl : newImageUrl+'?w='+imageSize" 
                        :size="imageSet.size"
                    />
                    
                </a>
            </div> -->
            <span class="productText" v-html="editing ? editData.description : product.description"></span>
            <div v-show="this.$root.admin && view == 'list'">
                    <productEdit :productData="product" @updateProductWithNewData="updateProductWithNewData" :productName="editData.name" @updateProduct="updateProduct" :contentID="product.WCMS_WebPageContent_ID" v-if="editing" :edit="product.edit" :desc="editData.description"
                        :imgUrl="product.imageUrl"></productEdit>
            </div>
            <div class="infoContainer">
                <a class="readMoreProductLink" :href="$root.pointshop ? basedir+$root.pointshopUrlPrefix+product.productPageLink : basedir+'/'+product.productPageLink" v-html="$root.language.wsm_MoreInfo"></a>
            </div>
        </div>
        <!-- <div class="productImage" v-if="view == 'list'  && !mobile">
            <a :href="$root.pointshop ? basedir+$root.pointshopUrlPrefix+product.productPageLink : basedir+'/'+product.productPageLink">
                <v-lazy-image 
                    :alt="product.name" 
                    :src-placeholder="product.imageUrl" 
                    :srcset="imageSet.set" 
                    :src="editing ? `${newImageUrl}?w=${imageSize}` : product.imageUrl+'?w='+imageSize"  
                    :size="imageSet.size" 
                    @error="handleImageError" 
                />
                
            </a>
        </div> -->
        <div class="buyBtnWrapper">
        <div v-for="(subProd, index) in product.products" :key="index" :class="[showBuyButtonLogic?'shop':'nonShop',(parseInt(subProd.discount) > 0 || subProd.taxRateFactor == 1) ? 'extraHeight' : '', 'productActionBar', $store.state.BasketLines.find(x => x.id == subProd.productId) && !$store.state.BasketLines.find(x => x.id == subProd.productId).isSubscription && $store.state.BasketLines.find(x => x.id == subProd.productId) && $store.state.BasketLines.find(x => x.id == subProd.productId).quantity > 0 && $root.subscriptionenabled ? 'extraPadding' : '']">
                <div class="infoWrapper">
                    <a :href="$root.pointshop ? basedir+$root.pointshopUrlPrefix+subProd.productPageLink : basedir+'/'+subProd.productPageLink+($root.subscriptionenabled ? '#variant='+subProd.productId : '')"> <span v-html="subProd.quantityString" class="quantityProduct"></span></a>
                    <p class="productPrice" v-if="subProd.availability != 2 && onlyBuyWhenLoggedInCheck && showBuyButtonLogic" v-html="getVisString(subProd.price)"></p>
                    <!-- <additionalInfo v-if="((view == 'grid' && (subProd.discount > 0 || $root.display.iscompany)) || (view == 'list' && mobile)) && !$root.pointshop" :data="subProd" :companyPriceIncludingVat="getVisString(subProd.companyPriceIncludingVat)" :listPrice="getVisString(subProd.listPrice)"
                        :localDiscount="getVisString(subProd.discount)" :tax="subProd.taxRateFactor" :showBuyButton="showBuyButtonLogic" /> -->
                    <additionalInfo v-if="((view == 'grid' && (subProd.discount > 0 || $root.display.iscompany)) || (view == 'list')) && !$root.pointshop" :data="subProd" :companyPriceIncludingVat="getVisString(subProd.companyPriceIncludingVat)" :listPrice="getVisString(subProd.listPrice)"
                        :localDiscount="getVisString(subProd.discount)" :tax="subProd.taxRateFactor" :showBuyButton="showBuyButtonLogic" />
                </div>
                <inventoryManagement :name="subProd.name" :id="subProd.productId" v-if="($root.admin || $root.localadmin)" />
                
                <div class="buttonAndInfoWrapper">
                <a v-if="view == 'list' || (view == 'list' && mobile)" class="infoLink" :href="$root.pointshop ? basedir+$root.pointshopUrlPrefix+subProd.productPageLink : basedir+'/'+subProd.productPageLink">
                    <div class="infoBtn">
                        <i class="fa fa-info"></i>
                    </div>
                </a>
                <addToBasket :isSubscriptionInBasket="isSubscriptionInBasket(subProd)" 
                :ref="'addToBasketBtn'+subProd.productId" 
                v-if="showBuyButtonLogic" 
                :class="['addToBasketButton', subProd.availability == 2 ? 'nosale' : '', $root.admin ? 'adminBtn' : '']" 
                @gtag="gtag" 
                :id="subProd.productId" 
                :quantity="quantity" 
                :availability="subProd.availability" 
                :restock="subProd.restockDate"
                :backorder="subProd.isBackorderAllowed" 
                :preorder="subProd.isPreorderAllowed" 
                :productname="subProd.variant_name" 
                :price="subProd.price"
                :pointCardPointValue="{
                    pointCardPointValue: subProd.pointCardPointValue,
                    CurrencyIso: subProd.CurrencyIso,
                    view: view,
                }"
                >
                </addToBasket>

                <!-- <a v-if="view == 'grid' || (view == 'grid' && mobile)" class="infoLink" :style="!showBuyButtonLogic ? '	float: right;margin-top: -3px;' : ''" :href="$root.pointshop ? basedir+$root.pointshopUrlPrefix+subProd.productPageLink : basedir+'/'+subProd.productPageLink"> -->
                <a v-if="view == 'grid' || (view == 'grid' && mobile)" class="infoLink"  :href="$root.pointshop ? basedir+$root.pointshopUrlPrefix+subProd.productPageLink : basedir+'/'+subProd.productPageLink">
                    <div class="infoBtn">
                        <i class="fa fa-info"></i>
                    </div>
                </a>
                </div>
                <div class="pointcardvalue" v-show="view != 'grid' && $root.pointshop && subProd?.pointCardPointValue > 0">
                    <p v-html="`${$root.language.wsm_pointcard_in_box}: ${subProd.pointCardPointValue} ${subProd.CurrencyIso}`"></p>
                </div>
                <!-- <additionalInfo v-if="((view == 'list' && !mobile) && (subProd.discount > 0 || $root.display.iscompany) || (view != 'grid' && !mobile)) && !$root.pointshop" :data="subProd" :companyPriceIncludingVat="getVisString(subProd.companyPriceIncludingVat)" :listPrice="getVisString(subProd.listPrice)"
                :localDiscount="getVisString(subProd.discount)" :tax="subProd.taxRateFactor" :showBuyButton="showBuyButtonLogic" /> -->
                <a class="savewithautoship" :style="`${ ((view == 'list' && !mobile) && (subProd.discount > 0 || $root.display.iscompany)) && !$root.pointshop ? '': ''}`" v-if="$store.state.BasketLines.find(x => x.id == subProd.productId) && !$store.state.BasketLines.find(x => x.id == subProd.productId).isSubscription && $store.state.BasketLines.find(x => x.id == subProd.productId) && $store.state.BasketLines.find(x => x.id == subProd.productId).quantity > 0 && $root.subscriptionenabled && subProd.isAllowSubscription && !$root.pointshop" :href="$root.pointshop ? basedir+$root.pointshopUrlPrefix+product.productPageLink : basedir+'/'+product.productPageLink+'#variant='+subProd.productId+'&savewithsub=true'">{{ $store.state.BasketLines.find(x => x.id == subProd.productId) && $store.state.BasketLines.find(x => x.id == subProd.productId).isSubscription ? '' : $root.language.wsm_sub_subavailable }}</a>
                <p v-if="subProd.restockDate && subProd.availability == 0 && restockDateisInTheFuture(subProd.restockDate)" class="restockDate">{{ restockDate(subProd.restockDate) }}</p>
            </div>
        

    </div>
        
    </div>
</template>

<script>
import VLazyImage from "v-lazy-image";
import addToBasket from "./addToBasket";
import additionalInfo from "./additionalInfo";
// CODE SPLITTING - There is linking issues when in development.
    // The chunks cannot handle our /pndk/ stuff 
var priceHandler = require('../../../globalComponents/visualFormattingForPrices');
var fetch = require('../../../globalComponents/fetchImageUrl');
import productEdit from "./productEdit.vue";
import inventoryManagement from "./inventoryManagement.vue";
import PromotionLabel from './promotionlabel.vue'

import * as Bowser from "bowser";
  const fallBackBrowserVersions = {
    Chrome: 31,
    Edge: 17,
    Safari:15.6,
    Firefox: 64,
    Opera:18,
    AndriodBrowser: 4.1,
    KaiOSBrowser:2.5
  };
  
export default {
    props:["product", "quantity", "view","backorder","flaptype","restock"],    
    components: {
        VLazyImage,
        addToBasket,
        additionalInfo,
        inventoryManagement: () => window.shopPageObj.$root.admin || window.shopPageObj.$root.localadmin ?
            import ('./inventoryManagement.vue') : '',
        productEdit: () => window.shopPageObj.$root.admin ?
            import ('./productEdit.vue') : '',
        PromotionLabel
    },
    mounted() {
        this.loading = true;
        this.mobile = this.$store.state.mobile;
        if (this.$root.admin) {
            this.$set(this.product, 'edit', false);
        }
        this.setNewImageUrl(this.product);
        this.loading = false;
    },
    watch: {
        view: {
            handler() {
                if (this.view == 'grid') {}
            }
        },
        editing: {
            handler(newVal) {
                if (newVal) {
                    this.$set(this.editData, 'description', this.descDesc)
                    this.$set(this.editData, 'name', this.product.name)
                    this.$set(this.editData, 'imageUrl', this.checkImageUrl(this.product.imageUrl))
                }
            }
        },
        product: function(newproduct, oldProduct) {
            if(newproduct.imageUrl !== oldProduct.imageUrl) {
                this.setNewImageUrl(newproduct);
            }
        }
    },
    provide() {
        return {
            product: this.product
        }
    },
    data() {
        return {
            mobile: false,
            editing: false,
            mobileSize: 412,
            imageSrcSets: [1, 1.3, 1.6, 2, 2.5, 2.8],
            loading: true,
            originalSize: 243,
            originalgridImgSize: 220,
            showSuborSingleLink: [],
            editData: {
                description: '',
                name: '',
                imageUrl: '',
            },
            newImageUrl: "",
        }
    },
    methods: {
        setNewImageUrl: function(product) {
            this.loading = true;
            this.getImageUrl(product).then((result) => {
                this.newImageUrl = result;
            }).catch(() => {
                this.newImageUrl = this.product.imageUrl;
            });
            this.loading = false;
        },
        handleImageError: function() {
            this.newImageUrl = this.product.imageUrl;
        },
       getImageUrl: function(product) {
            return new Promise(async(resolve, reject) => {
               setTimeout(() => {
                    const result = this.checkImageUrl(product.imageUrl);
                    resolve(result);
               }, 100);
            });
        },
        updateProduct: function(newVal) {
            switch (newVal.type) {
                case 'setDesc':
                    this.editData.description = newVal.val
                    break;
                case 'cancel' || 'stopEdit':
                    this.editing = false;
                    this.editData = {
                        description: '',
                        name: '',
                        imageUrl: '',
                    }
                    break;
                case 'setName':
                    this.editData.name = newVal.val
                    break;
                case 'setImage':
                    this.editData.imageUrl = newVal.val
                    break;
            }
        },
        gtag: function(id, name, price) {
            if(!this.$root.pointshop) {
                gtag('event', 'add_to_cart', {
                    currency: this.product.products[0].CurrencyIso,
                    value: parseFloat(price),
                    "items": [{
                        'item_name': name,
                        'item_id': id,
                        'price': parseFloat(price)
                    }],
                    'event_category': 'Single',
                });
                if(window.hasFbq) {
                    fbq('track', 'AddToCart', {
                        content_ids: [id],
                        content_name: name,
                        currency: this.product.products[0].CurrencyIso,
                        value: parseFloat(price)
                    });
                }
                if(window.hasReddit && window.redditPixelReady && typeof rdt === 'function') {
                    rdt('track', 'AddToCart', {
                        value: parseFloat(price),
                        currency: this.product.products[0].CurrencyIso,
                        itemCount: 1,
                        conversionId: crypto.randomUUID?.() || String(Date.now()),
                        products: [{
                            id: String(id),
                            name: name,
                            quantity: 1,
                            itemPrice: parseFloat(price)
                        }]
                    });
                }
                    //VWO splittesting
                    window._vis_opt_queue = window._vis_opt_queue || [];
                    window._vis_opt_queue.push(function() {_vis_opt_goal_conversion(200);});
            }
                
        },
        updateProductWithNewData: async function(val) {
            this.product.name = val.name;
            this.product.imageUrl = val.image;
            this.product.description = val.description;
            this.editing = false;
        },
        getVisString: function(money) {
            return priceHandler.default.visualFormattingForPrices(money, this.product.products[0].CurrencyIso, this.product.products[0].currencyPrecision, this.product.products[0].locale)
        },
       
        checkImageUrl : async function(url) {
            const imageParams = {
                url           : url,
                sku           : this.product.products[0].sku_no,
                flap          : "",
                fileExtension : this.isBrowserCompatableForWebPImages,
                size          : "",
            };
            imageParams.flap= this.$root.flaptype;
            try{
                const fetchImage = fetch.default;
                return await fetchImage(imageParams);
            } catch(error){
                console.log("error loading component:",error);
            };
        },
        isSubscriptionInBasket(subProd){
            const basketLine = this.$store.state.BasketLines.find(x => x.id == subProd.productId);
            return basketLine ? basketLine.isSubscription : false;
        },
        restockDate(restock) {
            return this.$root.language.wsm_expectedrestock.replace('$$__DATE__$$', new Date(restock).toLocaleDateString(window.locale.replace('_', '-'), { year: 'numeric', month: 'short', day: 'numeric' })) 
        },
        restockDateisInTheFuture(restock) {
            return new Date(restock) > new Date();
        }
    },
    computed: {
        filteredPromotion() {
            const filtered = this.product.products.filter(item => item?.promotionAttributes?.length > 0)[0];
            return filtered ? filtered.promotionAttributes : null;
        },
        hasPromotion() {
            return this.filteredPromotion !== null;
        },
        isBrowserCompatableForWebPImages(){
          return Number(Bowser.version) > fallBackBrowserVersions[Bowser.name]? "webp" : "png";
       },
        imageSize: function() {
            return this.view == 'grid' ? 220 : 337;
        },
        imageSet: function() {
            var mode = 'x' //w, x
            var returnObj = {}
            var sizeAttr = [];
            var srcString = '';
            this.imageSrcSets.forEach((size, index) => {
                switch (mode) {
                    case 'x':
                        srcString += this.newImageUrl + '?w=' + Math.floor(this.imageSize * size) + ' ' + size + 'x' + ((index + 1) == this.imageSrcSets.length ? '' : ', ')
                        return {
                            set: srcString,
                            size: ''
                        };
                        break;
                    case 'w':
                        srcString += this.newImageUrl + '?w=' + Math.floor(this.imageSize * size) + ' ' + Math.floor(this.imageSize * size) + 'w' + ((index + 1) == this.imageSrcSets.length ? '' : ', ')
                        sizeAttr.push(Math.floor(this.imageSize * size))
                        break;
                }
            })
            returnObj["set"] = srcString;
            if (mode == 'w') {
                returnObj["size"] = sizeAttr;
            } else {
                returnObj["size"] = '';
            }
            return returnObj
        },
        imageWidthOnPhone: function() {
            return (window.outerWidth - (window.outerWidth * 0.1038)) + 5
        },
        descDesc: {
            get: function() {
                if ((typeof this.product != 'undefined' && typeof this.product.description != 'undefined') && this.product.description != "") {
                    var txt = document.createElement("textarea");
                    txt.innerHTML = this.product.description.trim();
                    return txt.value;
                } else {
                    return ''
                }


            },
            set: function(newValue) {
                 if ((typeof this.product != 'undefined' && typeof this.product.description != 'undefined') && this.product.description != "") {
                     this.product.description = newValue.trim()
                 } else {
                     this.product["description"] = ''
                 }
            }
        },
        showAdditionalInfo: function() {
            if (parseInt(this.product.discount) > 0 || this.product.taxRateFactor == 1) {
                return true;
            } else {
                return false;
            }
        },
        productDesc: function() {
            if ((typeof this.product != 'undefined' && typeof this.product.description != 'undefined') && this.product.description != "") {
                return this.product.description.replace(/\s\s+/g, ' ').replace(/(\r\n|\n|\r)/gm, '').replace(/(<([^>]+)>)/ig, '').trim();
            }

        },
        basedir: function() {
            return window.basedir;
        },
        location: () => {
            return window.location
        },
        locale: () => {
            return window.locale
        },
        showBuyButtonLogic: function() {
            if (this.$root.display.showPriceNoBuyButton && !this.$root.admin) {
                return false;
            } else {
                if (this.onlyBuyWhenLoggedInCheck) {
                    return true
                } else {
                    return false;
                }
            }
        },

        onlyBuyWhenLoggedInCheck: function() {
            if (this.$root.display.OnlyBuyWhenLoggedIn) {
                if (this.$root.display.loggedIn) {
                    return true;
                } else {
                    return false;
                }
            } else {
                return true
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.pointcardvalue p {
    font-size: 0.8rem;
    color: #575757;
    font-weight: 600;
}

.savewithautoship {
	margin-bottom: 0;
	font-size: 0.9rem;
	margin-top: 0.4rem;
	font-weight: bold;
    grid-column: 2;
    grid-row: 2;
    justify-self: flex-end;
}

.addToBasketButton{
    display: flex;
    flex-grow: 1;
}

.productContainer {
    width: 100%;
    text-align: center;
    margin: 0 auto;
    //margin-top: 2px;
    clear: both;
    margin-bottom: 20px;
    padding: 20px 0px; 

    //HGHANSEN
    display: grid;
    grid-template-columns: 50% 50%;
    grid-template-rows: auto;

    // products with a promotion label: frame in the label colour, label as a tab on top
    &:has(.promotion-label span) {
        position: relative;
        box-sizing: border-box;
        border: 2px solid;
        border-radius: 0 6px 6px 6px;
        margin-top: 26px;
        padding: 12px;
    }
    &:has(.promotion-label .special) {
        border-color: #35c1b6;
    }
    &:has(.promotion-label .campaign) {
        border-color: #ffa500;
    }
    &:has(.promotion-label .new) {
        border-color: #2196F3;
    }

    .promotion-label {
        position: absolute;
        top: -2px;
        left: -2px;
        transform: translateY(-100%);
        margin: 0;
        z-index: 5;
    }
}

.buyBtnWrapper{
    grid-row: 2;
    display: flex;
    flex-direction: column;
    gap: 5px;
}

.productActionBar {
    padding: 10px;
    background: #f5f2e8;
    text-align: left;
    display: grid;
    // grid-template-columns: 80% 1fr;
    //grid-template-columns: 50% min-content 1fr;
    grid-template-columns: fit-content(40ch) auto minmax(auto, min-content);
    grid-template-rows: auto;
    border-radius: 3px;
    gap: 3px;
    align-items: center;

    .infoWrapper{
        grid-column: 1;
    }
    .buttonAndInfoWrapper{
        grid-column: 2;
        grid-row: 1;
        flex-direction: row-reverse;
    }
    .additionalInfoWrapper{
        grid-column: 1;
        grid-row: 2;
    }
    .plep{
        grid-column: 3;
        justify-self: flex-end;
    }
    .restockDate {
        grid-column: 1 / -1;
        justify-self: flex-start;
        font-size: 0.8rem;
        color: #796e5e;
        margin-top: 0.5rem;
        margin-bottom: 0;
    }
}
// .infoWrapper{
//     grid-column: span 2;
//     grid-row: 1;
// }
.productPrice {
    display: inline-block;
    margin-left: 8px;
    font-weight: bold;
    color: #004570;
    span {
        font-weight: bold;
        color: #004570;
    }
}

hr {
    width: 87%;
}

.infoBtn {
    min-width: 30px;
    min-height: 30px;
    text-align: center;
    background: #8d8877;
    border-radius: 2px;
    padding: 0px;
    float: unset;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    i {
        color: #f5f2e8;
    }
}

.buttonAndInfoWrapper{
    display: flex;
    align-items: center;
    gap: 10px;
    grid-column: span 2;
    grid-row: 2;
}
.infoLink, .grid .infoLink{
    display: flex;
    justify-content: center;
    align-items: center;
    width:auto;
    height: 100%;
    margin-bottom: 0;
    grid-column: 2;
    grid-row: 2;
    min-height: 30px;
}
.grid .addToBasketButton, .addToBasketButton{
    width: 100%;
    display: flex;
    justify-content: flex-end;
}


.list .productInfo{
    min-height: auto!important;
}


.productActionBar.nonShop, .grid .productActionBar.nonShop{
    grid-template-columns: auto;
    grid-template-rows: 1fr;
    .infoWrapper{
        grid-column: 1;
    }
    .buttonAndInfoWrapper{
        grid-column: 2;
        grid-row: 1;
        justify-self: flex-end;
    }
    .additionalInfoWrapper{
        grid-column: 3;
        grid-row: 1;
    }
    .infoLink{
        grid-row: 1;
        width: auto;
        justify-self: flex-end;
        // justify-content: flex-end;
    }
}
.productActionBar.nonShop > *{
    grid-row: unset;
}



.grid {
    .productContainer {
        grid-template-columns: 1fr;
        border: 2px solid #f5f2e8;
        border-top-left-radius: 6px;
        border-top-right-radius: 6px;
        padding: 0px;
        margin: 0;
        display: flex;
        flex-direction: column;
        flex-grow: 1;

        // grid cards already have a frame and sit in the grid gap: keep their own spacing
        &:has(.promotion-label span) {
            padding: 0;
            margin: 0;
        }
    }

    .productContainer {
        .productImage{
            grid-row: 1;
            grid-column: 1;
        }
        .productInfo{
            grid-row: 2;
            grid-column: 1;
        }
        .buyBtnWrapper{
            grid-row: 3;
            grid-column: 1;
        }
    }

    .productActionBar {
        .addToBasketButton{
            display: block;
        }
        .infoWrapper{
            grid-column: span 2;
        }
        .buttonAndInfoWrapper{
            grid-column: span 3;
            grid-row: 3;
            align-items: start;
            flex-direction: unset;
        }
        .additionalInfoWrapper{
            grid-row: 2;
            grid-column: span 2;
        }
        .savewithautoship{
            grid-row: 4;
            grid-column: span 2;
            justify-self: flex-start;
        }
    } 

  
    h3 {
        text-align: left;
        margin-bottom: 8px;
        color: #796e5e;
        margin-top: 11px;
        // padding: 14px;
        padding-bottom: 0;
    }
    .productImage {
        display: block;
        width: auto;
        img {
            //width: 100%;
            margin: 0 auto;
            max-height: 134px;
            max-width: 100%;
        }
    }
    .savewithautoship {

        margin-bottom: 1rem;
	    text-align: left;
    }
    .extraPadding {
        //padding-bottom:30px;
    }
    .productInfo {
        width: 100%;
        // display: block;
        background: rgba(245, 242, 232, 0.41);
        text-align: left;
        padding: 14px;
        box-sizing: border-box;
        flex: 1;
        display: flex;
        flex-direction: column;
        &>a {
            margin-bottom: 9px;
            display: block;
        }
        &>span {
            width: 87%;
            display: block;
            text-align: left;
            // padding: 7%;
            padding-top: 0;
            font-size: 0.85em;
            word-break: break-word;
        }
        .readMoreProductLink {
            font-weight: 700;
            display: block;
            margin-top: 18px;
            font-size: 15px;
            margin: 0;
            // padding: 7%;
            padding-top: 0;
        }
        
        .infoContainer {
            display: flex;
            flex-direction: column;
            align-items: flex-start;
            justify-content: space-between;
            margin-top: auto;
            .subAvailable {
                font-size: 0.8rem;
                margin-left: 7%;
                background: #e8b75e;
                margin-bottom:2rem;
                color: white;
                padding: 0 0.5rem 0 0.5rem;
                border-radius: 6px;
                text-transform: uppercase;
            }
        }
    }
    .productText{
        margin-bottom: 10px;
    }
}

//HGHANSEN

.productInfo {
    display: inline-block;
    text-align: left;

    //HGHANSEN
    display: grid;
    max-width: none;
    grid-column: 1;
    grid-row: 1;
    margin-top: 0px;
    margin-right: 0;
    &>a {
        margin-bottom: 9px;
        display: block;
        sup {
            font-size: 0.5em;
            color: #796e5e;
        }
    }
    h3 {
        text-align: left;
        width: auto;
        display: inline-block;
        sup {
            font-size: 0.5em;
            color: #796e5e;
        }
    }
    .extraHeight {
        min-height: 36px;
        height: 1px;
    }
    .readMoreProductLink {
        font-weight: 700;
        display: block;
        margin-top: 18px;
        font-size: 15px;
    }
    .infoContainer {
        display: flex;
        align-items: center;
        justify-content: space-between;
        .subAvailable {
            font-size: 0.8rem;
            background: #e8b75e;
            color: white;
            padding: 0 0.5rem 0 0.5rem;
            border-radius: 6px;
            text-transform: uppercase;
        }
    }

    // Comment out or remove the .campaign-label styles if they're no longer needed
    // .campaign-label {
    //     display:flex;           
    //     font-family: "Open Sans";
    //     font-weight: bold;
    //     font-size: 1em;
    //     color: white;
    //     padding: 2px 15px;
    //     border-radius: 11px;
    //     margin-bottom: 24px;
    //     letter-spacing: 2px;
    //     position:relative;

    //     span{
    //         max-width: 200px;
    //         background-color: #FF9800;
    //         box-shadow: 6px 4px 0px #d27f03;
    //         color:white;
    //         padding: 6px 13px;                
    //         rotate: -5deg;
    //         font-weight: bold;
    //         letter-spacing: 2px;


    //         &:before,
    //         &:after {
    //             background: inherit;
    //             content: '';
    //             display: block;
    //             height: 33%;
    //             left: 0;
    //             position: absolute;
    //             right: 0;
    //             z-index: -1;
    //             -webkit-backface-visibility: hidden; // for Chrome Windows
    //         }

    //         &:before {
    //             top: 0;
    //             transform: skewY(2.5deg);
    //             transform-origin: 100% 0;
    //         }

    //         &:after {
    //             bottom: 0;
    //             transform: skewY(-2.5deg);
    //             transform-origin: 100%;
    //             box-shadow: 6px 6px 0px #d27f03;
    //         }
    //     }                
    // }
}
.btn {
    background: white;
    font-size: 1em;
    border-radius: 4px;
    cursor: pointer;
    font-weight: bold;
    text-transform: uppercase;
    margin-left: 5px;
    margin-right: 5px;
    transition: all 0.2s ease-in-out;
    i {
        font-size: 0.8em;
        transition: all 0.2s ease-in-out;
        padding-right: 5px;
        color: #004570;
    }
    &:hover {
        color: white !important;
        i {
            color: white;
        }
    }
}
.edit {
    border: 2px solid #004570;
    color: #004570;
    float: right;
    &:hover {
        background: #004570;
    }
}

.list {
    .adminProductTextEdit {
        textarea {
            font-size: 1em;
            font-family: monospace;
            background: #ebf0f4;
            color: #121212;
            border-radius: 6px;
            border: 2px solid #004570;
            box-shadow: 2px 2px 20px 0px #dddddd;
        }
        .save {
            border: 2px solid #7caf63;
            color: #7caf63;
            &:hover {
                background: #7caf63;
            }
        }
        .cancel {
            border: 2px solid #e88282;
            color: #e88282;
            &:hover {
                background: #e88282;
            }
        }
    }

    .productImage {
        // min-width: 304px;
        // position: absolute;
        margin-top: 23px;
        // right: 1%;

        //HGHANSEN
        grid-column: 2;
        grid-row-start: span 2;
        position: initial;
        margin-top: 0px;
        img {
            margin: 0 auto;
            height: 204px;
            max-width: 100%;
        }
    }
}



.productShopMoble {
    .list {
        .productInfo {
            width: 100%;
            margin-bottom: 10px;
        }
        .productActionBar {
            width: 94%;
        }
        .productImage {
            display: block;
            width: 100%;
        }
    }
}

@media screen and (max-width: 900px) {
    .grid {
        .addToBasketButton {
            width: 80%;
        }
    }
}

.bounce-enter-active {
    animation: bounce-in .3s;
}

.bounce-leave-active {
    animation: bounce-in .3s reverse;
}

@keyframes bounce-in {
    0% {
        transform: scale(0);
    }
    50% {
        transform: scale(1.02);
    }
    100% {
        transform: scale(1);
    }
}

.turquoiseTheme {
    .productActionBar {
        background: #f3fafb;
    }
    .grid {
        .productContainer {
            border: 2px solid #eafbfd;
            .productInfo {
                background: #f3fafb;
            }
            .productActionBar {
                background: #e4f3f5;
            }
        }
    }
}



@media screen and (max-width: 1000px){

    .productContainer{
        .infoWrapper{
            grid-column: 1;
            grid-row: 1;
        }
        .productImage{
            grid-column: 2;
            grid-row: 1;
        }
        .buyBtnWrapper{
            grid-column: span 2;
            grid-row: 2;
        }
    }
}

@media screen and (max-width: 700px){
    .productContainer{
        grid-template-columns: 1fr;
        .productInfo{
            grid-column: 1;
            grid-row: 2;
        }
        .productImage{
            grid-column: 1;
            grid-row: 1;
        }
        .buyBtnWrapper{
            grid-column: 1;
            grid-row: 3;
        }
    }
    .addToBasketButton{
        display: block;
    }

    .productActionBar {
        //grid-template-columns: 80% 1fr;
        grid-template-rows: auto;

        .infoWrapper{
            grid-column: span 2;
            grid-row: 1;
        }
        .buttonAndInfoWrapper{
            grid-column: span 2;
            grid-row: 2;  
        }
        .additionalInfoWrapper{
            grid-column: 1;
            grid-row: 3;
        }
        .savewithautoship{
            grid-column: 2;
            grid-row: 3;
            justify-self: flex-end;
        }
    }
}
</style>

<style lang="scss">
.productActionBar .additionalInfoWrapper .additionalInfo{
    display: unset;
}
@media screen and (max-width: 665px){
    .productInfo{
        min-height: auto!important;
    }
}

.productContainer span p,
.productActionBar p {
    margin: 0;
}

.productContainer .productText {
    /* Height handled by flexbox on parent */
}

.grid .productInfo>span>p {
    color: #796e5e;
    font-size: 13px;
}

.list .productInfo>span {
    display: block;
}

.quantityProduct {
    display: inline-block;
    font-weight: bold;
    text-align: left;
    min-width: 58px;
}

.list .quantityButtons {
    width: 91px;
}

.grid {
    h3 {
        sup {
            font-size: 0.5em;
            color: #796e5e;
            font-weight: bold;
        }
    }
}

.list {
    h3 {
        sup {
            font-size: 0.5em;
            font-weight: bold;
        }
    }
}


</style>
